import { useContext, useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'

import { useLocation } from '../../Location/Location.hook'
import { QuizQuestionContext, SCREEN_QUIZ_QUESTION } from '../../../contextAPI'
import { PATH_URL, upsertQuizResponse } from 'src/helpers'
import { QuizType } from 'src/pages/shared'
import { QuizResponse } from 'src/types'

export const useNewPlanningStage = (quizType?: QuizType) => {
  const history = useHistory()
  const { data, setQuizScreen, weddingDateData } = useContext(QuizQuestionContext)
  const [stage, setStage] = useState<string>(data.planningStage?.stage ?? '')
  const location = useLocation()

  const navigateNext = () => {
    if (quizType === QuizType.PINTEREST) {
      history.push({
        pathname: PATH_URL.GUEST_COUNT,
        search: new URLSearchParams({ quizType }).toString(),
      })
    } else {
      history.push({ pathname: PATH_URL.GUEST_COUNT })
    }
    setQuizScreen(SCREEN_QUIZ_QUESTION.GUEST_COUNT)
  }

  const persistAndAdvance = (nextStage: string) => {
    const currentTempPoppyData = JSON.parse(localStorage.getItem('tempPoppySessionData') || '{}')
    const responses: QuizResponse[] = upsertQuizResponse(
      currentTempPoppyData.quizResponses || [],
      'PLANNING_STAGE',
      nextStage
    )

    localStorage.setItem('tempPoppySessionData', JSON.stringify({ ...currentTempPoppyData, quizResponses: responses }))

    setTimeout(() => {
      navigateNext()
    }, 600)
  }

  const handleBack = async () => {
    if (window.history.length > 1) {
      history.goBack()
    } else {
      if (quizType === QuizType.PINTEREST) {
        history.push({
          pathname: PATH_URL.NEW_COLOR_PALETTE_PAGE,
          search: new URLSearchParams({ quizType }).toString(),
        })
        setQuizScreen(SCREEN_QUIZ_QUESTION.NEW_COLOR_PALETTE_PAGE)
      } else {
        history.push({ pathname: PATH_URL.YOUR_DETAILS })
        setQuizScreen(SCREEN_QUIZ_QUESTION.YOUR_DETAILS)
      }
    }
  }

  const handleChangeStage = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target
    setStage(value)
    persistAndAdvance(value)
  }

  const handleClickStage = (value: string) => {
    if (value === stage) {
      persistAndAdvance(value)
    }
  }

  useEffect(() => {
    const dataFromLocal = JSON.parse(localStorage.getItem('tempPoppySessionData') || '{}')
    const quizResponsesFromLocal: QuizResponse[] = dataFromLocal?.quizResponses || []
    const stageFromLocal = quizResponsesFromLocal.find((e) => e.key === 'PLANNING_STAGE')
    setStage(data.planningStage?.stage || (stageFromLocal?.values as string) || '')
  }, [data.planningStage?.stage])

  return {
    data,
    location,
    weddingDateData,
    handleBack,
    stage,
    handleChangeStage,
    handleClickStage,
  }
}
